module.exports = __webpack_public_path__ + "static/media/unavailable_gray.b0f980e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/unavailable_gray.png
// module id = 2449
// module chunks = 0